import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tag-autocomplete"
export default class extends Controller {
  static targets = ["input", "dropdown", "list"]

  connect() {
    // Get all available tags from the page
    this.allTags = Array.from(document.querySelectorAll('.tag-suggestion'))
                       .map(btn => btn.dataset.tagName);
    this.currentSuggestionIndex = -1;
  }

  handleInput(event) {
    const query = event.target.value.split(',').pop().trim().toLowerCase();

    if (query.length < 1) {
      this.hideSuggestions();
      return;
    }

    const matches = this.allTags.filter(tag =>
      tag.toLowerCase().includes(query) &&
      !this.getCurrentTags().includes(tag)
    ).slice(0, 5);

    if (matches.length > 0) {
      this.showSuggestions(matches, query);
    } else {
      this.hideSuggestions();
    }
  }

  showSuggestions(matches = null, query = '') {
    if (matches) {
      this.listTarget.innerHTML = matches.map((tag, index) =>
        `<div class="tag-autocomplete__item" data-tag="${tag}" data-index="${index}">
          #${tag}
         </div>`
      ).join('');

      // Add click listeners
      this.listTarget.querySelectorAll('.tag-autocomplete__item').forEach(item => {
        item.addEventListener('mousedown', (e) => {
          e.preventDefault(); // Prevent blur
          this.selectTag(item.dataset.tag);
        });
      });
    }

    this.dropdownTarget.style.display = 'block';
    this.currentSuggestionIndex = -1;
  }

  hideSuggestions() {
    setTimeout(() => {
      this.dropdownTarget.style.display = 'none';
    }, 150);
  }

  selectTag(tagName) {
    const input = this.inputTarget;
    const currentValue = input.value;
    const tags = currentValue.split(',').map(t => t.trim());

    // Replace the last incomplete tag with the selected one
    tags[tags.length - 1] = tagName;

    input.value = tags.join(', ') + ', ';
    input.focus();
    this.hideSuggestions();
  }

  getCurrentTags() {
    const currentValue = this.inputTarget.value.trim();
    return currentValue ? currentValue.split(',').map(t => t.trim()).filter(t => t) : [];
  }
}